import html from '../legacy/gpu.html?raw';
import { LegacyHtmlPage } from './LegacyHtmlPage';

export function Gpu() {
  return <LegacyHtmlPage slug="gpu" title="GPUs" html={html} />;
}
